import React, { useCallback } from 'react'
import WorkspaceReportsTable from './WorkspaceReportsTable';
import { MotifButton, MotifFormField, MotifSearch } from '@ey-xd/motif-react';
import AddUpdateReport from './AddUpdateReport';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const WorkspaceReports = () => {
    const [reportAddOrUpdateEnabled, setReportAddOrUpdateEnabled] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);
    const { workspaceReports } = useSelector((state: any) => state.workspaces);  
    const { access } = useSelector((state: any) => state.user);
    const dispatch = useDispatch();
    const params = useParams()
    const [search, setSearch] = React.useState('');

    const toggleReportAddOrUpdateEnabled = () => {
        setReportAddOrUpdateEnabled(!reportAddOrUpdateEnabled);
    }

    const reportsList = useCallback(() => {
        if (reportAddOrUpdateEnabled === true) return <></>
        const reports =  search === ''
        ? workspaceReports
        : workspaceReports?.filter((wksp: any) => {
          if (
            wksp.reportName.toLowerCase().includes(search.toLowerCase()) ||
            wksp.createdDate.toLowerCase().includes(search.toLowerCase()) ||
            wksp.reportStatus.toLowerCase().includes(search.toLowerCase())
          ) {
            return wksp;
          }
        })
        return (
            <div className="flex flex-col gap-3">
                <div className="flex justify-between items-center gap-3">
                    <h3>Below listed are the reports you created:</h3>
                    <div className="flex justify-between items-center gap-3">
                        <MotifFormField className="!max-w-[20rem] !mb-0">
                            <MotifSearch
                                aria-label="Search"
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                }}
                                onSelect={function Xo() { }}
                                placeholder="Search for..."
                                value={search}
                                maxLength={25}
                            />
                        </MotifFormField>
                        {access?.write === true && (
                            <MotifButton
                                size="medium"
                                onClick={() => {
                                    dispatch({ type: 'WORKSPACE_CLEAR_REPORT_DETAILS'});
                                    setReportAddOrUpdateEnabled(true)
                                    setIsEdit(false)
                                }}
                                variant="primary"
                            >Add new document</MotifButton>
                        )}
                    </div>
                </div>
                <div>
                    <WorkspaceReportsTable tableData={reports} onOpenReport={() => {
                setReportAddOrUpdateEnabled(true)
                setIsEdit(true)
            }} />
                </div>

            </div>
        )
    }, [reportAddOrUpdateEnabled, workspaceReports, search]);

    const addNewReport = useCallback(() => {
        if (reportAddOrUpdateEnabled === false) return <></>
        return (
            <AddUpdateReport onCancel={() => {
                toggleReportAddOrUpdateEnabled();
            }} isEdit={isEdit} />
        )
    }, [reportAddOrUpdateEnabled]);
    return (
        <div>
            {reportsList()}
            {addNewReport()}
        </div>
    )
}

export default WorkspaceReports